





















import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';

import { getCalculationStatusColor, getCalculationStatusTooltip } from '../utils';

@Component({
    components: {}
})
export default class CalcStatus extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({ default: null }) calculationStatus: null | object;
    @Prop({ default: false }) isSowing: boolean;
    @Prop({ default: 'Estado del recálculo:' }) calcName: string;
    @Prop({ default: false }) isClasification: boolean;
    phases: string = 'harvest_calculation_phases';
    process: string = 'harvest_calculation_process';
    phasesSowing: string = 'sowing_calculation_phases';
    classificationPasses: string = 'sowing_classification_phases';
    calculationPhases: Array<object> = [];
    calculationProcess: Array<object> = [];

    @Watch('$_getInsuranceProperties', { immediate: true, deep: true })
    observableProperties() {
        this.assignPropertiesData();
    }

    assignPropertiesData(){
        this.calculationPhases = this.getPhasesOptions();
        this.calculationProcess = this.$_getInsuranceProperties[this.process];
    }

    getPhasesOptions(){
        let phaseKey = this.phases;
        if(this.isSowing && !this.isClasification){
            phaseKey = this.phasesSowing;
        }
        if(this.isClasification){
            phaseKey = this.classificationPasses
        }
        return this.$_getInsuranceProperties[phaseKey]
    }

    mounted() {
        let self = this;
        this.$nextTick(() => {
             self.assignPropertiesData();
        });
       
    }

    get getCalculationStatus() {
        let type = this.isSowing ? 1 : 0;

        if(
            this.calculationPhases && this.calculationPhases.length
            ){
            return getCalculationStatusTooltip(
                this.calculationStatus,
                this.calculationPhases,
                this.calculationProcess,
                type,
                this.isClasification
            )
        }
    }

    getCalculationStatusTone() {
        return getCalculationStatusColor(this.calculationStatus);
    }
}
